<template>
  <div class="x-tablelist-view" data-automation="keyList">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @changeTime="changeTime"
      @change="change"
      @search="seach"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :emptyText="$t('HT.nodata')"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          type: 'select',
          placeholder: '环境',
          options: [
            {
              value: '0',
              label: '国内'
            },
            {
              value: '1',
              label: '国外'
            }
          ],
          key: 'type',
          event: 'change'
        },
        {
          type: 'select',
          placeholder: '时区选择',
          options: [
            {
              label: '中时区',
              value: '0'
            },
            {
              label: '东一区',
              value: '1'
            },
            {
              label: '东二区',
              value: '2'
            },
            {
              label: '东三区',
              value: '3'
            },
            {
              label: '东四区',
              value: '4'
            },
            {
              label: '东五区',
              value: '5'
            },
            {
              label: '东六区',
              value: '6'
            },
            {
              label: '东七区',
              value: '7'
            },
            {
              label: '东八区',
              value: '8'
            },
            {
              label: '东九区',
              value: '9'
            },
            {
              label: '东十区',
              value: '10'
            },
            {
              label: '东十一区',
              value: '11'
            },
            {
              label: '东十二区',
              value: '12'
            },
            {
              label: '西一区',
              value: '-1'
            },
            {
              label: '西二区',
              value: '-2'
            },
            {
              label: '西三区',
              value: '-3'
            },
            {
              label: '西四区',
              value: '-4'
            },
            {
              label: '西五区',
              value: '-5'
            },
            {
              label: '西六区',
              value: '-6'
            },
            {
              label: '西七区',
              value: '-7'
            },
            {
              label: '西八区',
              value: '-8'
            },
            {
              label: '西九区',
              value: '-9'
            },
            {
              label: '西十区',
              value: '-10'
            },
            {
              label: '西十一区',
              value: '-11'
            },
            {
              label: '西十二区',
              value: '-12'
            }
          ],
          key: 'timeZoneType',
          event: 'change'
        },
        {
          type: 'date',
          daterange: true,
          time: true,
          event: 'changeTime'
        },
        {
          type: 'input',
          key: 'imei',
          placeholder: '请输入imei进行搜索'
        }
      ],
      columns: [
        // 表头数据
        {
          label: '子应用',
          prop: 'sub_application',
          tooltip: true
        },
        {
          label: '服务器',
          prop: 'logger_host',
          tooltip: true
        },
        {
          label: '日志内容',
          prop: 'message',
          tooltip: true
        }
      ],
      filter: {
        // 查询参数
        timeZoneType: '',
        imei: '',
        startTime: '',
        endTime: '',
        page: 1,
        size: 10,
        type: ''
      },
      apiList: [], // api 列表
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },

  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getLogList(params) {
      this.$api.log.getLogList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 搜索
     */
    seach() {
      if (this.filter.type == '') {
        this.$uxModal.hide();
        this.$uxMessage.warning('请选择环境');
        return;
      }
      if (this.filter.timeZoneType == '') {
        this.$uxModal.hide();
        this.$uxMessage.warning('请选择时区');
        return;
      }
      if (this.filter.startTime == '' || this.filter.startTime == undefined) {
        this.$uxModal.hide();
        this.$uxMessage.warning('请选择时间');
        return;
      }
      if (this.filter.imei == '') {
        this.$uxModal.hide();
        this.$uxMessage.warning('请输入imei号');
        return;
      } else {
        this.getLogList(this.filter);
        this.filter.page = 1;
      }
    },

    change() {
      this.filter.page = 1;
    },

    /**
     * 时间筛选
     * @param {Array} array 起始时间数组
     */
    changeTime(array) {
      this.filter.page = 1;
      this.filter.startTime = array[0];
      this.filter.endTime = array[1];
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getLogList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getLogList(this.filter);
    }
  }
};
</script>
